import type React from 'react';
import { memo } from 'react';

import * as styles from './styles';
import Box from '@material-ui/core/Box';
import moment from 'moment-timezone';

import { MediaType } from '@cobliteam/common-types';

import { DescriptionTitle, Divider, RadioButton } from '@cobliteam/base-components';

import Videocam from '@mui/icons-material/Videocam';

import useMediaStore from '../../../../store/zustand/useMediaStore';

export const MediaTypeSelectionStep: React.FC = memo(() => {
  const mediaRequestData = useMediaStore((state) => state.requestMediaData);
  const setMediaRequestData = useMediaStore((state) => state.setRequestMediaData);

  const onChangeOptionTimelapse = () => {
    setMediaRequestData({
      ...mediaRequestData,
      mediaType: MediaType.TIMELAPSE,
      requestMinute: undefined,
    });
  };

  const onChangeOptionFootage = () => {
    let requestMinute;

    if (mediaRequestData?.requestPeriodStart) {
      const startTimeMoment = moment(mediaRequestData.requestPeriodStart);
      const hour = startTimeMoment.hour();
      const minute = startTimeMoment.minute();

      requestMinute = `${hour < 10 ? `0${hour}` : hour}:${minute < 10 ? `0${minute}` : minute}`;
    }

    setMediaRequestData({
      ...mediaRequestData,
      mediaType: MediaType.FOOTAGE_VIDEO,
      requestMinute,
    });
  };

  return (
    <div className={styles.contentWrapper}>
      <div className={styles.headerIconLine}>
        <Videocam />
        <DescriptionTitle>Escolher categoria do vídeo</DescriptionTitle>
      </div>
      <Divider />
      <div className={styles.mediaTypeSelectionSection}>
        <div className={styles.block} onClick={onChangeOptionFootage}>
          <Box className={styles.optionBox}>
            <RadioButton checked={mediaRequestData?.mediaType === MediaType.FOOTAGE_VIDEO} value={MediaType.FOOTAGE_VIDEO} label='Vídeo de um trecho (até 1 minuto)' />
          </Box>
          <video loop autoPlay muted controls={false} className={styles.videoBox}>
            <source src='https://static.cobli.co/videos/videoMinuto1.mp4' type='video/mp4' />
          </video>
        </div>
        <div className={styles.block} onClick={onChangeOptionTimelapse}>
          <Box className={styles.optionBox}>
            <RadioButton checked={mediaRequestData?.mediaType === MediaType.TIMELAPSE} value={MediaType.TIMELAPSE} label='Resumo do trajeto (time-lapse)' />
          </Box>
          <video loop autoPlay muted controls={false} className={styles.videoBox}>
            <source src='https://static.cobli.co/videos/videoTimelapse2.mp4' type='video/mp4' />
          </video>
        </div>
      </div>
    </div>
  );
});

export default MediaTypeSelectionStep;
